import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { ConsumerRewardListPage } from '../consumer-reward-list/consumer-reward-list';
import { ConsumerOfferUserListPage } from '../consumer-offer-user-list/consumer-offer-user-list';

/**
 * Generated class for the ConsumerRedeemablesMainPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-consumer-redeemables-main',
  templateUrl: 'consumer-redeemables-main.html',
})
export class ConsumerRedeemablesMainPage {
	offers = ConsumerOfferUserListPage;
	rewards = ConsumerRewardListPage;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ConsumerRedeemablesMainPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/consumer-redeemables-main/consumer-redeemables-main.ts